import { Pagination } from '@heroui/react';
import React from 'react';

interface OrderPaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
}

export const OrderPagination: React.FC<OrderPaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  isLoading = false,
}) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex items-center justify-between px-6 py-4 border-t border-default-200">
      <div className="text-sm text-default-500">
        Showing {Math.min((currentPage - 1) * 25 + 1, totalItems)} to{' '}
        {Math.min(currentPage * 25, totalItems)} of {totalItems} orders
      </div>
      <Pagination
        total={totalPages}
        page={currentPage}
        onChange={onPageChange}
        isDisabled={isLoading}
        showControls
        showShadow
      />
    </div>
  );
};
